import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import {
  FETCH_ALL_ORDER_BOOK,
  FETCH_BUY_ORDER_BOOK,
  FETCH_SELL_ORDER_BOOK,
} from '../actions/orderbook/action_types';

import actions from '../actions/orderbook';
import rf from '../../requests/RequestFactory';

// saga effect

function* fetchAllOrderBook(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('OrderBookRequest').fetchAllOrderBook(params), action.params.data);
    yield put(actions.fetchAllOrderBookActionSucceed(data));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchAllOrderBookActionFailed(err));
  }
}

function* fetchBuyOrderBook(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('OrderBookRequest').fetchBuyOrderBook(params), action.params.data);
    yield put(actions.fetchBuyOrderBookActionSucceed(data));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchBuyOrderBookActionFailed(err));
  }
}

function* fetchSellOrderBook(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('OrderBookRequest').fetchSellOrderBook(params), action.params.data);
    yield put(actions.fetchSellOrderBookActionSucceed(data));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchSellOrderBookActionFailed(err));
  }
}

function* watchAllOrderBooks() {
  yield takeLatest(FETCH_BUY_ORDER_BOOK, fetchBuyOrderBook);
  yield takeLatest(FETCH_SELL_ORDER_BOOK, fetchSellOrderBook);
  yield takeLatest(FETCH_ALL_ORDER_BOOK, fetchAllOrderBook);
}

export default function* rootSaga() {
  yield all([fork(watchAllOrderBooks)]);
}
